import { Plugin, PluginKey } from "prosemirror-state";

export const selectedTextMenuPluginKey = new PluginKey("selected-text-menu");

export const selectedTextMenuPlugin = ({
  onChange = () => false,
  onExit = () => false,
}) =>
  new Plugin({
    key: selectedTextMenuPluginKey,
    view() {
      return {
        update: (view, prevState) => {
          const state = view.state;

          if (prevState && prevState.doc.eq(state.doc) && prevState.selection.eq(state.selection)) {
              return;
          }

          if (state.selection.empty) {
            if (!prevState.selection.empty) {
              onExit?.();
            }
            return;
          }

          const { from, to } = state.selection;

          onChange?.({
            view,
            range: {
              from,
              to,
            },
          });
        },
        destroy() {
          onExit?.();
        }
      };
    },
  });
